export default __webpack_public_path__ + "static/media/x.fee8e594.svg";